import moment from "moment";
import {IServiceInterval} from "shared-types/DiaryTypes";
import {cloneDeep, isEmpty} from "lodash-es";

class CustomIntervalsService {


  // basically this is a function that gets trigger when you change the
  // duration or times, it needs to recalculate the boxes but also
  // it needs to preserve the existing ones.

  getCustomIntervalsForService(service: {startTime: Date, endTime: Date, intervalsCustom: IServiceInterval[]}, bookingIntervals: string): IServiceInterval[] {

    const clonedService = cloneDeep(service);
    const intervals = parseInt(bookingIntervals)

    if (clonedService.startTime !== undefined) {
      service.intervalsCustom = [];

      const startTime = moment(service.startTime);
      const endTime = moment(service.endTime);
      const durationInMinutes = moment.duration(endTime.diff(startTime)).asMinutes();

      // try to figure out the actual range for the number of boxes we need
      const ranges = Array.from(Array(Math.floor(durationInMinutes / intervals) + 1).keys());

      ranges.forEach((range) => {
        const intervalTime = moment(service.startTime).add((range * intervals), 'minutes').format('h:mm a');

        // need to sort this out, if has a value already.
        const customInterval: IServiceInterval = {
          intervalDuration: bookingIntervals,
          times: intervalTime,
          values: this.getValueOrNone(clonedService, intervalTime)
        };

        service.intervalsCustom.push(customInterval);
      })
    }
    return service.intervalsCustom;
  }


  private getValueOrNone(service: {startTime: Date, endTime: Date, intervalsCustom: IServiceInterval[]}, time: string): string {

    if (!isEmpty(service.intervalsCustom)) {
      for (let val = 0; val < service.intervalsCustom.length; val++) {
        if (service.intervalsCustom[val].times === time) {
          if ((service.intervalsCustom[val].values == null || service.intervalsCustom[val].values === '') && service.intervalsCustom[val].values !== '0') {
            return '';
          }
          return service.intervalsCustom[val].values;
        }
      }
    }
    return '';
  }

}

const instance = new CustomIntervalsService();
export default instance as CustomIntervalsService;
